import { ClientEndpointJsonVersion, ClientEndpointType, FabricClientEndpoint, getClientEndpointJsonVersionDisplayName } from "@app/shared";
import { useModel } from "@app/shared/src/hooks";
import { EnumSelect, Input, InputRow } from "@app/dashboard/src/components/shared/inputs";
import { useHref } from "react-router-dom";
import { apiDocsHrefForEndpoint } from "../EndpointApiDocs/specRegistry";
import { ClientEndpointEditorProps } from "./ClientEndpointEditor";

type EditFabricClientEndpointProps = {
} & ClientEndpointEditorProps;

export const EditFabricClientEndpoint: React.FC<EditFabricClientEndpointProps> = (props) => {
    const endpointWithDefaults = !!!props.endpoint?.id ? { ...props.endpoint, jsonVersion: 2 } : props.endpoint;
    const [, helper] = useModel(FabricClientEndpoint, endpointWithDefaults as FabricClientEndpoint);
    const onChange = (newEndpoint: Partial<FabricClientEndpoint>) => {
        props.onChange({ ...newEndpoint as FabricClientEndpoint, endpointType: ClientEndpointType.Fabric });
    };
    // Resolved through the shared spec registry, which picks the document for this endpoint type and
    // handles hosts that don't bundle the docs page: WebConfig gets an absolute dashboard URL via
    // docsOrigin, the dashboard gets an in-app path under its basename (works behind the device proxy).
    const appBaseHref = useHref("/");
    const docsHref = apiDocsHrefForEndpoint(
        { endpointType: ClientEndpointType.Fabric },
        { docsOrigin: props.docsOrigin, hostsDocsPage: !props.offlineMode, appBaseHref }
    );

    return (
        <>
            {docsHref && (
                <InputRow>
                    <a href={docsHref} target="_blank" rel="noopener noreferrer" className="text-link-page underline text-sm">
                        View the Microsoft Fabric Event Stream documentation (setup, payload schema, delivery) ↗
                    </a>
                </InputRow>
            )}
            <InputRow><Input label="Endpoint Name" {...helper.bindingsFor("endpointName", onChange)} /></InputRow>
            <InputRow><Input label="Connection String" placeholder="Endpoint=sb://<namespace>.servicebus.windows.net/;SharedAccessKeyName=...;SharedAccessKey=...;EntityPath=..." {...helper.bindingsFor("connectionString", onChange)} /></InputRow>
            <InputRow><Input label="Event Hub Name" placeholder="Optional — overrides EntityPath from the connection string" {...helper.bindingsFor("eventHubName", onChange)} /></InputRow>
            <InputRow><EnumSelect enumType={ClientEndpointJsonVersion} nameToDisplayConverter={getClientEndpointJsonVersionDisplayName} {...helper.bindingsFor("jsonVersion", onChange)} /></InputRow>
        </>
    );
}
